import { TOPUP_CONFIG_COMMON } from '../../common/const/topup.const'

export const TOPUP_CONFIG = Object.assign({}, TOPUP_CONFIG_COMMON, {
  topupAmounts: [10, 25, 30, 50],
  topupAmountMin: 10,
  topupAmountMax: 250
})
